export enum TagCategory {
  heat = "heat",         
  status = "status",    
  typology = "typology",   
  custom = "custom"     
}

export const TagCategoryExclusive: Record<TagCategory, boolean> = {
  [TagCategory.heat]: true,
  [TagCategory.status]: true,
  [TagCategory.typology]: false,
  [TagCategory.custom]: false,
}

export const TagCategoryLabel: Record<TagCategory, string> = {
  [TagCategory.heat]: "Chaleur",
  [TagCategory.status]: "Statut",
  [TagCategory.typology]: "Typologie",
  [TagCategory.custom]: "Custom",
}